import { useEffect } from 'react';

interface SchemaData {
  '@context': string;
  '@type': string;
  [key: string]: unknown;
}

interface SEOSchemaProps {
  data: SchemaData | SchemaData[];
}

export default function SEOSchema({ data }: SEOSchemaProps) {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    // Replace placeholder URLs with actual site URL
    const processedData = JSON.parse(
      JSON.stringify(data).replace(/https:\/\/example\.com/g, siteUrl)
    );

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(processedData);
    script.id = 'seo-schema-' + Math.random().toString(36).substr(2, 9);
    document.head.appendChild(script);

    return () => {
      const existingScript = document.getElementById(script.id);
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, [data]);

  return null;
}
